<template>
     <div class="systemparameter-registration">
        <b-form  v-show="mode === 'save' || mode === 'remove' || mode === 'read'">
              <b-row>
                 <b-col md="4" sm="12">
                    <b-form-group 
                        label="Operation (Service Provider):" 
                        label-for="systemparameter-operation_id_provider_service">
                        <b-select 
                            id="systemparameter-operation_id_provider_service"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="operations" 
                            @input="loadOperationsLevelOneOperations"
                            v-model="systemparameter.operation_id_provider_service" 
                            />
                    </b-form-group>
                </b-col>
                 <b-col md="6" sm="12">
                    <b-form-group 
                        label="Category (Service Provider):" 
                        label-for="systemparameter-operation_level_one_id_provider_service">
                        <b-select 
                            id="systemparameter-operation_level_one_id_provider_service"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="operationslevelones" 
                            v-model="systemparameter.operation_level_one_id_provider_service" 
                            />
                    </b-form-group>
                </b-col>
             </b-row>
            <b-row>
                  <b-col md="4" sm="12">
                    <b-form-group 
                        label="Operation (Invoice):" 
                        label-for="systemparameter-operation_id_invoice">
                        <b-select 
                            id="systemparameter-operation_id_invoice"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="operations" 
                            @input="loadOperationsLevelOneOperationsInvoice"
                            v-model="systemparameter.operation_id_invoice" 
                            />
                    </b-form-group>
                </b-col>
                 <b-col md="6" sm="12">
                    <b-form-group 
                        label="Category (Invoice):" 
                        label-for="systemparameter-operation_level_one_id_invoice">
                        <b-select 
                            id="systemparameter-operation_level_one_id_invoice"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="operationsleveloneinvoces" 
                            v-model="systemparameter.operation_level_one_id_invoice" 
                            />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4" sm="12">
                    <b-form-group 
                        label="Operation (Tenant):" 
                        label-for="systemparameter-operation_id_tenant">
                        <b-select 
                            id="systemparameter-operation_id_tenant"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="operations" 
                            @input="loadOperationsLevelOneOperationsTenant"
                            v-model="systemparameter.operation_id_tenant" 
                            />
                    </b-form-group>
                </b-col>
                 <b-col md="6" sm="12">
                    <b-form-group 
                        label="Category (Invoice):" 
                        label-for="systemparameter-operation_level_one_id_tenant">
                        <b-select 
                            id="systemparameter-operation_level_one_id_tenant"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="operationslevelonetenants" 
                            v-model="systemparameter.operation_level_one_id_tenant" 
                            />
                    </b-form-group>
                </b-col>
            </b-row>
         </b-form>
                <b-row>                   
                <b-col xs="12">
                    <b-button  
                        title="Add" 
                        size="sm" 
                        class="mt-2 mb-2 fa fa-plus" 
                        variant="dark" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="[mode_add = true,alterModo()]"></b-button>
                    <b-button  
                        title="Save"  
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save"></b-button>
                    <b-button  
                        title="Delete" 
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove"></b-button>
                    <b-button  
                        title="Back" 
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-ban"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset"></b-button>
                    <b-button  
                    size="sm" 
                    title="Search" 
                    class="mt-2 mb-2 ml-2 fa fa-search" 
                    @click="[loadParts(),toggleBusy(),showTable = !showTable]" 
                    variant="dark" 
                    v-show="mode !== 'save' && mode !== 'remove'"
                    >
                    </b-button>
                </b-col>
            </b-row>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
            <transition  name="slide" type="animation" appear>       
                <b-table 
                        :busy="isBusy"  
                        class="table-responsive" 
                        hover 
                        key="slide"  
                        head-variant="light" 
                        :per-page="perPage" 
                        :current-page="currentPage" 
                        :items="systemparameters" 
                        :fields="fieldsProvider">
                     <template v-slot:table-busy>
                        <div class="text-center text-info my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>loading...</strong>
                        </div>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <b-button 
                                title="View" 
                                size="sm" 
                                variant="light" 
                                @click="loadPart(data.item, 'read')" 
                                class="mr-2 mt-2">
                            <i class="fa fa-drivers-license-o"></i>
                        </b-button>
                        <b-button 
                            title="Edit" 
                            size="sm" 
                            variant="light" 
                            @click="loadPart(data.item)" class="mr-2 mt-2">
                            <i class="fa fa-pencil"></i>
                        </b-button>
                        <b-button 
                            title="Delete" 
                            size="sm" 
                            variant="light" 
                            @click="loadPart(data.item, 'remove')" 
                            class="mr-2 mt-2">
                            <i class="fa fa-trash"></i>
                        </b-button>
                    </template>
                </b-table>
            </transition>
            <b-pagination 
              v-model="currentPage" 
              :per-page="perPage"
              :total-rows="rows">
              </b-pagination> 
            </b-row>
      </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
var moment = require('moment')

export default {
         name: 'SystemParameter',
            directives: {moment},
                data: function() {
                return {
                    mode: 'insert',
                    mode_add:false,
                    search: '',
                    systemparameter: {},
                    systemparameters: [],
                    operations:[],
                    operationslevelones:[],
                    operationsleveloneinvoces:[],
                    operationslevelonetenants:[],
                    showTable: false,
                    showSearch: true,
                    isBusy: false,
                    currentPage: 1,
                    perPage: 5,
                    fieldsProvider: [
                        { key: 'name_operation', label: 'Operation (Provider)', sortable: true },
                        { key: 'name_operation_level_one', label: 'Category (Provider)', sortable: true },
                        { key: 'actions', label: 'Ações', variant: 'secondary' }
                    ]
                }
            },
            computed: {
                user(){
                    return this.$store.state.user
                },
                compan(){
                    return this.$store.state.compan
                },
                icon() {
                    return this.showTable ? "fa-retweet" : "fa-search"
                },
                 rows() {
                    return this.systemparameters.length
                }
            },
            methods: {
            formatDate (date) {
                return moment.utc(date).format('YYYY-MM-DD')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            loadParts() {
                const url = `${baseApiUrl}/systemparametersbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.systemparameters = res.data
                     this.isBusy = false
            })
            },
            reset() {
                this.mode = 'insert'
                this.mode_add = false
                this.loadParts()
            },
            alterModo() {
                        this.mode = 'save'
                        this.systemparameter = {}
                        this.$refs.searchFocus.focus();
                },
            save() {

                             this.systemparameter = {
                                ...this.systemparameter,
                                company_id_system_param: this.compan.id}

               
               const method = !this.mode_add ? 'put' : 'post'
               const id = !this.mode_add ? `/${this.systemparameter.company_id_system_param}` : ''

                axios[method](`${baseApiUrl}/systemparameters${id}`, this.systemparameter)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            remove() {
                const id = this.systemparameter.id
                axios.delete(`${baseApiUrl}/systemparameters/${id}`)
                    .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                    })
                    .catch(showError)
            },
            loadPart(systemparameter, mode = 'save') {
                this.mode = mode
                this.systemparameter = { ...systemparameter }
            },
            loadOperation() {
                    const url = `${baseApiUrl}/operations`
                        axios.get(url).then(res => {
                        this.operations = res.data.map(operation => {
                        return {
                        value: operation.id,
                        text: operation.name_operation
                        }
                        })
                    })
                },
             loadOperationsLevelOneOperations() {
                    const url = `${baseApiUrl}/operationslevelones/${this.systemparameter.operation_id_provider_service}/?company_id=${this.compan.id}`
                         axios.get(url).then(res => {
                            this.operationslevelones = res.data.map(operationslevelone => {
                            return {
                            value: operationslevelone.id,
                            text: operationslevelone.name_operation_level_one
                        }
                        })
                    })
                },
                loadOperationsLevelOneOperationsInvoice() {
                    const url = `${baseApiUrl}/operationslevelones/${this.systemparameter.operation_id_invoice}/?company_id=${this.compan.id}`
                         axios.get(url).then(res => {
                            this.operationsleveloneinvoces = res.data.map(operationslevelone => {
                            return {
                            value: operationslevelone.id,
                            text: operationslevelone.name_operation_level_one
                        }
                        })
                    })
                },
                loadOperationsLevelOneOperationsTenant() {
                    const url = `${baseApiUrl}/operationslevelones/${this.systemparameter.operation_id_tenant}/?company_id=${this.compan.id}`
                         axios.get(url).then(res => {
                            this.operationslevelonetenants = res.data.map(operationslevelone => {
                            return {
                            value: operationslevelone.id,
                            text: operationslevelone.name_operation_level_one
                        }
                        })
                    })
                },
                
             },
            mounted() {
                this.showTable = true
                this.loadParts()
                this.loadOperation()
            }
    }       
</script>

<style>

     .systemparameter-registration label {
        font-size: 0.75rem;
        color: black;
    }

    .systemparameter-registration select{
        font-size: 0.75rem;
    }
    .systemparameter-registration input{
        font-size: 0.75rem;
    }
    .systemparameter-registration textarea{
        font-size: 0.75rem;
    }
    .systemparameter-registration button{
        font-size: 0.75rem;
    }
    .systemparameter-registration table{
        font-size: 0.75rem;
    }

    @keyframes slide-in {
    from {transform: translateY(40px);}
    to {transform: translateY(0);}
    }

    @keyframes slide-out {
        from {transform: translateY(0);}
        to {transform: translateY(40px);}
    }

    .slide-enter-active {
    animation: slide-in 1s ease;
        transition: opacity 1s;
    }

    .slide-leave-active {
        animation: slide-out 1s ease;
        transition: opacity 1s;
    }

    .slide-enter, .slide-leave-to{
        opacity: 0;
    }

    .fade-enter, .fade-leave-to{
    opacity: 0;
    }

    .fade-enter-active, .fade-leave-active{
    transition: opacity 1s;
    }

</style>
